import React from 'react'
import ExpSectionHome from '../Experiences/ExpSectionHome'; 
import AbledSecHome from '../AbledTraveller/AbledSecHome';
import '../../App.css';
import "./Styles.css";
import HimalayanSecHome from '../Himalayan/HimalayanSecHome';
import Footer from '../../components/Footer/Footer';
import Img001 from './Images/iato.png';
import Img002 from './Images/travelife-partner.webp';


function AffiliateSecHome() {
  return (
    <>

      
      <div className=" containerAffiliate ">

            
      
                <div className=' w-10 h-10 flex items-center justify-center'> 
                    <img className=' ' width="80px" src={Img001} />                 
                </div>

                <div className=' w-10 h-10 flex items-center justify-center'> 
                    <img className='  '  width="170px" src={Img002} /> 
                </div>



      </div>
      

  
    

    
    </>
  )
}



export default AffiliateSecHome
